import { Field, FieldAttributes, FieldProps } from 'formik';
import { forwardRef, useMemo } from 'react';
import FloatingInput, { FloatingInputProps } from './FloatingInput';

interface FormikFloatingInputProps extends FloatingInputProps {
    fieldProps?: FieldAttributes<any>;
}

const FormikFloatingInput = forwardRef<HTMLInputElement, FormikFloatingInputProps>((props, ref) => {
    const { name, id, fieldProps, invalid, ...rest } = props;

    const idOrName = useMemo(() => {
        return id || name;
    }, [id, name]);

    return (
        <Field name={name} {...fieldProps}>
            {({ field, meta }: FieldProps) => (
                <FloatingInput
                    {...rest}
                    {...field}
                    ref={ref}
                    id={idOrName}
                    name={name}
                    invalid={(meta.touched && Boolean(meta.error)) || invalid}
                />
            )}
        </Field>
    );
});

export default FormikFloatingInput;
